module.exports = __webpack_public_path__ + "img/four4Blue.f8ba3fce.jpg";